import React from 'react';
import { useSelector } from 'react-redux';

import PageBlock from 'app/shared/componentsRestyled/common/PageBlock';
import { TableCDS } from 'app/shared/componentsRestyled/coreDesignSystem/Table';
import PropTypes from 'prop-types';

import { selectConsentTableData } from 'store/loanApplications/selectors';

import { consentTableConfig } from './Consent.config';

const Consent = ({ isLoading }) => {
  const tableData = useSelector(selectConsentTableData);

  return (
    <div className="mt-32">
      <PageBlock withDivider title="Consent">
        <TableCDS
          withNoAvailableMessage
          config={consentTableConfig}
          data={tableData}
          isLoading={isLoading}
          skeletonRows={3}
        />
      </PageBlock>
    </div>
  );
};

Consent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default Consent;
